import React from "react";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { withOktaAuth } from "@okta/okta-react";
import { Route, Redirect } from "react-router-dom";

import { isSukiUser } from "../../helpers/roles";
import { LO_STO } from "../../util/constants";

const SecureRoute = (props) => {
  const { authState, path } = props;

  const isAuthenticated = !_isEmpty(_get(authState, "idToken.idToken", ""));

  const loginPath = window.localStorage.getItem(LO_STO.CURRENT_PATH);

  if (!isAuthenticated && loginPath === "/") {
    return null;
  }

  if (path.includes("organizations") && !isSukiUser()) {
    return <Redirect to="/tokens" />;
  }

  return <Route {...props} />;
};

export default withOktaAuth(SecureRoute);
